module.exports = __webpack_public_path__ + "img/300x250_layout_2.a8fb7fcb.svg";